export default __webpack_public_path__ + "static/media/whiteCross.d99b4813.svg";